<template>
    <a href="/" title="home">

    <svg version="1.1"
         xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px"
         y="0px"
         class="h-10  fill-current"
         viewBox="0 0 300 63.06"
         style="overflow:visible;enable-background:new 0 0 300 63.06;"
         xml:space="preserve">
        <g>
	<path class="st0"
          d="M13.15,48.49c2.35,0,4.31-0.66,5.89-1.98c1.58-1.32,2.44-3.03,2.57-5.13h3.24c-0.09,1.86-0.68,3.55-1.74,5.08
		c-1.07,1.53-2.49,2.73-4.26,3.59c-1.77,0.86-3.67,1.29-5.7,1.29c-4,0-7.16-1.39-9.5-4.16c-2.33-2.78-3.5-6.51-3.5-11.2v-1.01
		c0-3,0.52-5.66,1.58-7.96s2.55-4.09,4.52-5.35c1.96-1.26,4.25-1.88,6.88-1.88c3.34,0,6.09,0.99,8.26,2.98
		c2.17,1.99,3.32,4.6,3.47,7.85h-3.24c-0.15-2.38-1.01-4.3-2.57-5.77c-1.57-1.46-3.54-2.19-5.92-2.19c-3.04,0-5.4,1.1-7.08,3.29
		c-1.68,2.19-2.52,5.27-2.52,9.23v0.99c0,3.88,0.84,6.91,2.52,9.09C7.73,47.4,10.09,48.49,13.15,48.49z"/>
            <path class="duration-100 opacity-0" :class="{'opacity-100':!smallState}"
                  d="M42.77,23.19c-0.71-0.13-1.47-0.2-2.28-0.2c-2.1,0-3.88,0.59-5.33,1.76c-1.45,1.17-2.49,2.87-3.11,5.11v20.9
		H28.7V20.33h3.29l0.06,4.84c1.78-3.6,4.64-5.4,8.58-5.4c0.94,0,1.68,0.12,2.22,0.36L42.77,23.19z"/>
            <path class="duration-100 opacity-0" :class="{'opacity-100':!smallState}"
                  d="M56.46,51.33c-2.59,0-4.93-0.64-7.02-1.91c-2.09-1.28-3.72-3.05-4.88-5.33c-1.16-2.28-1.74-4.83-1.74-7.67
		v-1.21c0-2.93,0.57-5.56,1.7-7.9c1.13-2.35,2.72-4.19,4.74-5.53c2.03-1.34,4.22-2.01,6.58-2.01c3.7,0,6.63,1.26,8.79,3.78
		c2.17,2.52,3.25,5.97,3.25,10.34v1.88H46.16v0.65c0,3.45,0.99,6.33,2.97,8.62c1.98,2.3,4.47,3.45,7.47,3.45
		c1.8,0,3.39-0.33,4.77-0.99c1.38-0.66,2.63-1.71,3.76-3.15l2.11,1.6C64.75,49.54,61.16,51.33,56.46,51.33z M55.83,22.63
		c-2.53,0-4.67,0.93-6.4,2.78c-1.74,1.86-2.79,4.35-3.17,7.48h18.26v-0.36c-0.09-2.93-0.93-5.31-2.5-7.15
		C60.45,23.55,58.39,22.63,55.83,22.63z"/>
            <path class="duration-100 opacity-0" :class="{'opacity-100':!smallState}"
                  d="M90.77,50.77c-0.34-0.96-0.55-2.37-0.65-4.25c-1.18,1.54-2.69,2.73-4.52,3.56c-1.83,0.83-3.77,1.25-5.81,1.25
		c-2.93,0-5.29-0.82-7.1-2.45c-1.81-1.63-2.71-3.69-2.71-6.19c0-2.96,1.23-5.31,3.7-7.03c2.47-1.72,5.9-2.59,10.31-2.59h6.11v-3.46
		c0-2.18-0.67-3.89-2.01-5.13c-1.34-1.25-3.3-1.87-5.87-1.87c-2.35,0-4.29,0.6-5.82,1.8c-1.54,1.2-2.31,2.64-2.31,4.33l-3.38-0.03
		c0-2.42,1.13-4.52,3.38-6.29c2.25-1.77,5.02-2.66,8.3-2.66c3.4,0,6.07,0.85,8.03,2.55c1.96,1.7,2.97,4.07,3.02,7.1v14.4
		c0,2.95,0.31,5.15,0.93,6.61v0.34H90.77z M80.19,48.35c2.25,0,4.26-0.54,6.03-1.63c1.77-1.09,3.06-2.54,3.87-4.36v-6.7h-6.02
		c-3.36,0.04-5.98,0.65-7.88,1.84c-1.89,1.19-2.84,2.83-2.84,4.91c0,1.71,0.63,3.12,1.9,4.25C76.52,47.78,78.17,48.35,80.19,48.35z"
            />
            <path class="duration-100 opacity-0" :class="{'opacity-100':!smallState}"
                  d="M104.77,12.53v7.79h6.3v2.76h-6.3v20.31c0,1.69,0.3,2.95,0.91,3.77c0.61,0.83,1.63,1.24,3.05,1.24
		c0.56,0,1.47-0.09,2.73-0.28l0.14,2.73c-0.88,0.32-2.08,0.47-3.6,0.47c-2.31,0-3.98-0.67-5.04-2.01c-1.05-1.34-1.58-3.32-1.58-5.92
		V23.08h-5.6v-2.76h5.6v-7.79H104.77z"/>
            <path class="duration-100 opacity-0" :class="{'opacity-100':!smallState}"
                  d="M114.97,11.53c0-0.63,0.21-1.17,0.62-1.61c0.41-0.44,0.97-0.66,1.69-0.66c0.71,0,1.28,0.22,1.7,0.66
		c0.42,0.44,0.63,0.97,0.63,1.61c0,0.63-0.21,1.16-0.63,1.59c-0.42,0.43-0.99,0.64-1.7,0.64c-0.71,0-1.28-0.21-1.69-0.64
		C115.18,12.7,114.97,12.17,114.97,11.53z M118.94,50.77h-3.38V20.33h3.38V50.77z"/>
            <path class="duration-100 opacity-0" :class="{'opacity-100':!smallState}"
                  d="M134.68,46.12l9.26-25.8h3.46l-11.37,30.44h-2.73l-11.42-30.44h3.46L134.68,46.12z"/>
            <path class="duration-100 opacity-0" :class="{'opacity-100':!smallState}"
                  d="M161.45,51.33c-2.59,0-4.93-0.64-7.02-1.91c-2.09-1.28-3.72-3.05-4.88-5.33c-1.16-2.28-1.74-4.83-1.74-7.67
		v-1.21c0-2.93,0.57-5.56,1.7-7.9c1.13-2.35,2.72-4.19,4.74-5.53c2.03-1.34,4.22-2.01,6.58-2.01c3.7,0,6.63,1.26,8.79,3.78
		c2.17,2.52,3.25,5.97,3.25,10.34v1.88h-21.72v0.65c0,3.45,0.99,6.33,2.97,8.62c1.98,2.3,4.47,3.45,7.47,3.45
		c1.8,0,3.39-0.33,4.77-0.99c1.38-0.66,2.63-1.71,3.76-3.15l2.11,1.6C169.75,49.54,166.16,51.33,161.45,51.33z M160.83,22.63
		c-2.53,0-4.67,0.93-6.4,2.78c-1.74,1.86-2.79,4.35-3.17,7.48h18.26v-0.36c-0.09-2.93-0.93-5.31-2.5-7.15
		C165.45,23.55,163.38,22.63,160.83,22.63z"/>
            <path class="duration-100"
                  d="M188.31,47.08c1.86,0,3.48-0.56,4.87-1.69c1.39-1.13,2.16-2.53,2.31-4.22h4.92c-0.09,1.74-0.69,3.4-1.8,4.98
		c-1.11,1.58-2.58,2.83-4.43,3.77s-3.8,1.41-5.87,1.41c-4.15,0-7.44-1.38-9.89-4.15c-2.45-2.77-3.67-6.55-3.67-11.35v-0.87
		c0-2.96,0.54-5.6,1.63-7.91c1.09-2.31,2.65-4.1,4.68-5.37s4.44-1.91,7.22-1.91c3.41,0,6.25,1.02,8.51,3.07
		c2.26,2.05,3.46,4.7,3.61,7.96h-4.92c-0.15-1.97-0.9-3.59-2.24-4.85c-1.34-1.27-3-1.9-4.97-1.9c-2.64,0-4.69,0.95-6.15,2.86
		c-1.45,1.9-2.18,4.66-2.18,8.26v0.99c0,3.51,0.72,6.21,2.17,8.1C183.56,46.13,185.63,47.08,188.31,47.08z"
                  :class="{'secondC-small':smallState}"/>
            <path class="duration-100 opacity-0" :class="{'opacity-100':!smallState}"
                  d="M213.34,43.14l7.09-22.82H226l-12.24,35.14c-1.89,5.06-4.9,7.59-9.03,7.59l-0.99-0.08l-1.94-0.37v-4.22
		l1.41,0.11c1.76,0,3.14-0.36,4.12-1.07c0.99-0.71,1.8-2.02,2.43-3.91l1.15-3.09l-10.86-30.1h5.68L213.34,43.14z"/>
            <path class="duration-100 opacity-0" :class="{'opacity-100':!smallState}"
                  d="M239.6,47.08c1.86,0,3.48-0.56,4.87-1.69c1.39-1.13,2.16-2.53,2.31-4.22h4.92c-0.09,1.74-0.69,3.4-1.8,4.98
		c-1.11,1.58-2.58,2.83-4.43,3.77s-3.8,1.41-5.87,1.41c-4.15,0-7.44-1.38-9.89-4.15c-2.45-2.77-3.67-6.55-3.67-11.35v-0.87
		c0-2.96,0.54-5.6,1.63-7.91c1.09-2.31,2.65-4.1,4.68-5.37c2.03-1.28,4.44-1.91,7.22-1.91c3.41,0,6.25,1.02,8.51,3.07
		c2.26,2.05,3.46,4.7,3.61,7.96h-4.92c-0.15-1.97-0.9-3.59-2.24-4.85c-1.34-1.27-3-1.9-4.97-1.9c-2.64,0-4.69,0.95-6.15,2.86
		c-1.45,1.9-2.18,4.66-2.18,8.26v0.99c0,3.51,0.72,6.21,2.17,8.1S236.92,47.08,239.6,47.08z"/>
            <path class="duration-100 opacity-0" :class="{'opacity-100':!smallState}"
                  d="M260.33,50.77h-5.2V7.55h5.2V50.77z"/>
            <path class="duration-100 opacity-0" :class="{'opacity-100':!smallState}"
                  d="M278.4,51.33c-4.13,0-7.48-1.36-10.07-4.07c-2.59-2.71-3.88-6.34-3.88-10.87v-0.96c0-3.02,0.58-5.72,1.73-8.09
		c1.15-2.37,2.77-4.23,4.84-5.57c2.07-1.34,4.32-2.01,6.74-2.01c3.96,0,7.03,1.3,9.23,3.91c2.19,2.61,3.29,6.34,3.29,11.2v2.17
		h-20.62c0.07,3,0.95,5.43,2.63,7.27c1.68,1.85,3.81,2.77,6.4,2.77c1.84,0,3.39-0.37,4.67-1.13c1.28-0.75,2.39-1.74,3.35-2.98
		l3.18,2.48C287.33,49.37,283.51,51.33,278.4,51.33z M277.76,24.04c-2.1,0-3.86,0.76-5.29,2.29c-1.42,1.53-2.31,3.67-2.64,6.43
		h15.25v-0.39c-0.15-2.64-0.86-4.69-2.14-6.15C281.66,24.77,279.93,24.04,277.76,24.04z"/>
            <path class="st0  duration-100"
                  d="M293.53,48.04c0-0.9,0.27-1.65,0.8-2.25c0.54-0.6,1.34-0.9,2.41-0.9c1.07,0,1.88,0.3,2.43,0.9
		c0.55,0.6,0.83,1.35,0.83,2.25c0,0.86-0.28,1.58-0.83,2.17s-1.36,0.87-2.43,0.87c-1.07,0-1.87-0.29-2.41-0.87
		C293.8,49.62,293.53,48.9,293.53,48.04z"
                  :class="{'dot-small':smallState}"/>
</g>
        <rect class="duration-100"
              width="290.04"
              height="3.18"

              :class="{'line-small':smallState}"
        />
</svg>
    </a>


</template>

<script>
    export default {
        name: "logo",
        props: ['classes'],
        created() {
            window.addEventListener('scroll',()=>{
                if (window.scrollY > 250 ){
                    this.smallState = true;
                } else {
                    this.smallState = false;
                }
            });
        },
        data: function() {
            return {
                smallState: false
            }

        }
    }
</script>

<style scoped>
    .secondC-small {
        transform: translateX(-49%);
    }

    .dot-small {
        transform: translateX(-78%);
    }

    .line-small {
        width: 19%;
        transform: translateY(4%);
    }

</style>
